export default function (obj) {
    let defaults = {};
    for(let index in obj) {
        defaults[index] = obj[index] ?? '';
    }
    return defaults;
}